import { IEnvironmentConfiguration } from './environment';

export const environmentConfiguration: IEnvironmentConfiguration = {
	apiBasePath: 'https://pilotpay-staging-api.activeaero.com',
	isProduction: false,
	frontendIdentityUrl: 'https://identity-service-ui-staging.peakplatform.io',
	backendIdentityUrl: 'https://identity-service-api-staging.peakplatform.io',
	allowedEmailDomains: ['ascentgl.net']
};
